<ion-menu menuId="main-menu" contentId="main-content" type="overlay">
  <ion-header class="main_header">
    <ion-toolbar class="side-toolbar toolbarState" >
      <div class="profle-wrap">
        <div class="profile-img">
          <div class="avatar-wrap">
            <img [src]="userData?.profile_pic" alt="Profile Avatar" />
          </div>
        </div>
        <div class="profile-text">
          <div class="profile-name">
            {{ userData?.first_name }} {{ userData?.last_name }}
          </div>
          <div class="profile-email">{{ userData?.alarm_email }}</div>
        </div>
        <div class="profile-settings">
          <ion-menu-toggle auto-hide="true" routerLinkActive="router-link-active">
            <ion-button color="primary" [routerLink]="['/pages/setting']"
              routerLinkActive="router-link-active">
              <ion-icon name="settings-outline"></ion-icon>
            </ion-button>
          </ion-menu-toggle>
        </div>
    
      </div>
    </ion-toolbar>
  </ion-header>
  <ion-content>
    <div class="menu-item-list">
      <ion-menu-toggle auto-hide="true" routerLinkActive="router-link-active">
        <div
          class="menu-item"
          [routerLink]="['/pages/my-alarm']"
          routerLinkActive="router-link-active"
        >
          <div class="slot-start">
            <div class="menuicon"><i class="ri-home-4-line"></i></div>
            <div class="menu-label">{{'Home' | translate}}</div>
          </div>
          <div class="note">{{activeAlarmCount}}</div>
        </div>
      </ion-menu-toggle>
      <ion-menu-toggle auto-hide="true">
        <div
          class="menu-item"
          [routerLink]="['/pages/view_files']"
          routerLinkActive="router-link-active"
        >
          <div class="slot-start">
            <div class="menuicon"><i class="ri-file-text-line"></i></div>
            <div class="menu-label">{{'files' | translate}}</div>
          </div>
        </div>
      </ion-menu-toggle>
      <ion-menu-toggle auto-hide="true">
        <div
          class="menu-item"
          [routerLink]="['/pages/car_company']"
          routerLinkActive="router-link-active"
        >
          <div class="slot-start"> 
            <div class="menuicon"><i class="ri-taxi-line"></i></div>
            <div class="menu-label">{{'cars' | translate}}</div>
          </div>
        </div>
      </ion-menu-toggle>
      <ion-menu-toggle auto-hide="true">
        <div
          class="menu-item"
          routerLinkActive="router-link-active"
          (click)="navigateToAlarmMap()"
        >
          <div class="slot-start">
            <div class="menuicon"><i class="ri-road-map-fill"></i></div>
            <div class="menu-label">{{'map' | translate}}</div>
          </div>
        </div>
      </ion-menu-toggle>
      <ion-menu-toggle auto-hide="true">
        <div
          class="menu-item"
          [routerLink]="['/pages/contactUs']"
          routerLinkActive="router-link-active"
        >
          <div class="slot-start">
            <div class="menuicon"><i class="ri-mail-line"></i></div>
            <div class="menu-label">{{'contact_us' | translate}}</div>
          </div>
        </div>
      </ion-menu-toggle>
      <ion-menu-toggle auto-hide="true">
        <div class="menu-item" (click)="logout()">
          <div class="slot-start">
            <div class="menuicon">
              <i class="ri-logout-circle-r-line"></i>
            </div>
            <div class="menu-label">{{'Logout' | translate}}</div>
          </div>
        </div>
      </ion-menu-toggle>
    </div>
  </ion-content>

  <ion-footer class="sideMenu-Footer">
    <div class="footer-text">
      <h6>
        {{'powerBy' | translate}}
        <span class="color-primary">WEBER RESCUE</span> Systems
      </h6>
      <p>{{'Version' | translate}} {{appVersion}}</p>
    </div>
    <div class="extralinks">
      <a (click)="goToTerms()">{{'Imprint' | translate}}</a>
      <a (click)="goToPrivacy()">{{'dataSecurity' | translate}}</a>
      <a (click)="navigateToChangeLog()">{{'changeLog' | translate}}</a>
    </div>
  </ion-footer>
</ion-menu>
